import React from "react";
import { isValNull, getPath } from "../../../utils/index";
import TableFields from "../../../constants/OrderPayout/DisputeTableFields.json";
import Table from "../../Common/Table/index";
import { getDashboardUrl } from "../../../views/Home";

const DisputeDetails = (props) => {
  const { trips } = props;
  const [disputes, setDisputes] = React.useState([]);

  React.useEffect(() => {
    const disputesTemp = [];
    trips.map((trip, index) => {
      getPath(trip, "disputes", []).map((dispute, index2) => {
        disputesTemp.push(dispute);
      });
    });
    setDisputes(disputesTemp);
  }, []);

  if (isValNull(trips) || trips.length === 0) {
    return <p>Trips Not Found</p>;
  }

  const getFieldValue = (item, key) => {
    if (key === "reported_by") {
      return (
        item[key] + (item["reported_by_id"] ? "#" + item["reported_by_id"] : "")
      );
    }
    if (key === "reported_for") {
      return item[key] + " #" + item["reported_for_id"];
    }
    if (key === "created_at") {
      return new Date(item[key]).toLocaleString();
    }
    if (key === "view") {
      return (
        <span
          onClick={() =>
            window.open(
              item["id"]
                ? getDashboardUrl() + `/admin/disputes/${item["id"]}`
                : window.location.origin + `/disputes/${item["id_v2"]}`,
              "_blank"
            )
          }
          className={"edit-options cursor-pointer"}
        >
          View
        </span>
      );
    }
    if (key === "id"){
      return item["id"] ? item["id"] : item["id_v2"];
    }
    return item[key];
  };

  return (
    <React.Fragment>
      {disputes.length ? (
        <Table
          fields={TableFields}
          list={disputes}
          getFieldValue={getFieldValue}
        />
      ) : (
        <p>No disputes on this Order.</p>
      )}
    </React.Fragment>
  );
};

export default DisputeDetails;
